import { TEpic }          from 'Redux/Config';
import Actions            from 'Redux/Actions';
import { ofType }         from 'redux-observable';
import { mergeMap }       from 'rxjs';
import { UserRepository } from 'Domain/Repositories';

export const authenticationRequestEpic: TEpic = (action$) => action$.pipe(
  ofType(Actions.authenticationRequest.type),
  mergeMap((action) =>
    UserRepository.login({ mail: action.payload.username, password: action.payload.password })
      .then(userData => Actions.authenticationSuccess({ ...userData }))
      .catch(Actions.authenticationFailure),
  )
);
